import './Toolbar.css';
import HowToPlayButton from './HowToPlayButton.js';
import StatsButton from './StatsButton.js';
import ThemeToggle from './themeToggle.js';
import CalendarButton from './CalendarButton.js';
import AccountButton from './AccountButton.js';

const Toolbar = ({ isDarkMode, onToggle, stats, showHowToPlay, handleDateChange, completedQuizDates, date, onHome, gameMode }) => {
  const isGameActive = gameMode === 'classic' || gameMode === 'connections';

  return (
    <div className="toolbar">
      <div className="toolbar-left">
        <h1 className="toolbar-logo" onClick={onHome}>m🙂jie</h1>
      </div>
      <div className="toolbar-right">
        <div className="toolbar-button"><ThemeToggle onToggle={onToggle} isDarkMode={isDarkMode} /></div>
        {isGameActive && (
          <>
            <div className="toolbar-button"><HowToPlayButton isDarkMode={isDarkMode} showHowToPlay={showHowToPlay} gameMode={gameMode} /></div>
            <div className="toolbar-button"><StatsButton isDarkMode={isDarkMode} stats={stats} gameMode={gameMode} /></div>
            <div className="toolbar-button"><CalendarButton isDarkMode={isDarkMode} handleDateChange={handleDateChange} completedQuizDates={completedQuizDates} date={date} gameMode={gameMode} /></div>
          </>
        )}
        <div className="toolbar-button"><AccountButton isDarkMode={isDarkMode} /></div>
      </div>
    </div>
  );
};

export default Toolbar;
